import FancyButton from "@/components/ui/fancy-button";

const NotFoundView = ({ message }: { message: string }) => (
  <div className="flex min-h-[75vh] flex-col items-center justify-center">
    <h1 className="text-4xl font-bold text-gray-900">Page Not Found</h1>
    <p className="mt-4 text-lg text-gray-600">{message}</p>
    <FancyButton
      href="/"
      semiFancy
      className="mt-8 w-fit rounded-lg bg-blue-600 px-6 py-3 text-white hover:bg-blue-700"
    >
      Go back home
    </FancyButton>
  </div>
);

export default NotFoundView;
